/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2025, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import {
  Component, ElementRef, Injector, Input,
} from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Angular wrapper for the legacy AngularJS `bulbBlock` component.
 *
 * This component enables interoperability between AngularJS and Angular
 * by upgrading the AngularJS directive so it can be used in Angular templates.
 */
@Component({
  selector: 'bulb-block',
  template: '',
  standalone: false,
})
export class UpgradedBlockComponent extends UpgradeComponent {

  /**
   * The unit data object associated with the block.
   */
  @Input() unit: any;

  /**
   * The tile configuration for this block.
   */
  @Input() tile: any;

  /**
   * Identifier of the group this block belongs to.
   */
  @Input() groupId: any;

  /**
   * Whether current user has update group permission.
   */
  @Input() canUpdate: boolean;

  /**
   * Array of pinned unit IDs belonging to the group.
   */
  @Input() pinnedUnitIds: string[];

  /**
   * Creates an instance of UpgradedBlockComponent.
   *
   * @param elementRef - Reference to the host DOM element.
   * @param injector - Angular dependency injector.
   */
  constructor(elementRef: ElementRef, injector: Injector) {
    super('bulbBlock', elementRef, injector);
  }
}
